import { useState } from 'react';

const categories = ['全部', '醫療與保障', '壽險與家庭責任', '退休與長照', '保單健檢與理賠'];

const faqs = [
  {
    category: '退休與長照',
    q: '什麼是「候鳥式養老」？',
    a: '「候鳥式養老」是近年常見的養老方式，如候鳥隨季節移動，依四季變化到不同地方旅遊或生活。這類生活型態需要一定的退休金與醫療保障支撐，建議及早規劃現金流與健康風險，確保在不同地點生活時都有足夠的保障與資金。',
  },
  {
    category: '退休與長照',
    q: '巧用 4 帳戶規劃養老生活，是什麼意思？',
    a: '可分為基礎帳戶、應急帳戶、家長帳戶、獎勵帳戶。基礎帳戶支應日常生活開銷；應急帳戶處理突發醫療與風險；家長帳戶保留支持家庭的能力；獎勵帳戶則用於旅遊、興趣與生活品質。四個帳戶各司其職，讓退休生活更有結構與安全感。',
  },
  {
    category: '退休與長照',
    q: '商業養老保險有哪些常見種類？',
    a: '常見包括傳統型養老險、分紅型養老險與萬能型養老險。不同商品有不同繳費方式、領取方式與風險屬性，建議依照退休目標、現金流與風險承受度評估，並與專業顧問討論最適合的組合。實際商品條款與保障內容，仍需依各保險公司規定為準。',
  },
  {
    category: '壽險與家庭責任',
    q: '購買壽險時，影響核保的因素有哪些？',
    a: '常見因素包含職業類型、健康狀況、年齡、生活習慣、病史、家族病史與財務狀況。不同保險公司與商品的核保規則不同，實際仍需依個案評估。若有特殊健康狀況，建議事先與顧問討論，選擇最適合的投保方式。',
  },
  {
    category: '保單健檢與理賠',
    q: '什麼是保單貸款？',
    a: '保單貸款是以具保單價值準備金的保單向保險公司借款，通常適用於部分長年期壽險或年金險。需注意若貸款本息累積過高，可能影響保單效力。實際貸款條件、利率與規定，仍需依各保險公司保單條款為準。',
  },
  {
    category: '壽險與家庭責任',
    q: '年輕媽媽需要配置什麼保險？',
    a: '可優先考慮醫療險、重大疾病險、意外險與定期壽險。若不是家庭主要經濟支柱且預算有限，可依需求排序逐步配置。各險種功能不同，不能完全互相取代，建議與顧問討論後，依照家庭結構與預算做出最適合的選擇。',
  },
  {
    category: '保單健檢與理賠',
    q: '保險停效期間發生事故，可以理賠嗎？',
    a: '一般而言，停效期間發生事故，保險公司通常不負理賠責任。但若仍在寬限期內並完成繳費，保單效力可能不受影響。實際情況需依條款與保險公司規定判斷，建議遇到相關問題時，直接向保險公司或顧問確認。',
  },
  {
    category: '保單健檢與理賠',
    q: '保險可以中途轉保嗎？',
    a: '多數情況需要退保後重新投保，少數商品可能有保單轉換或活化機制。轉換前需注意健康狀況、年齡、等待期、保費與保障缺口，不建議貿然退舊買新。建議先做保單健檢，確認現有保單的優缺點後，再評估是否需要調整。',
  },
  {
    category: '醫療與保障',
    q: '為什麼買保險會有年齡限制？',
    a: '因為不同年齡層的風險機率不同，保險公司會依精算與承保規則設定年齡範圍。通常越早規劃，健康條件與保費彈性較高。若已超過某些商品的投保年齡，仍有其他適合的保障選項，建議與顧問討論替代方案。',
  },
  {
    category: '醫療與保障',
    q: '為什麼老人和小孩也需要意外險？',
    a: '老人身體機能下降，跌倒與意外風險較高；小孩自我保護能力較弱，也容易發生燒燙傷、跌倒或誤食等意外。意外險保費相對親民，是基礎保障的重要一環。投保前需確認條款保障範圍與除外責任，實際理賠仍依保單條款為準。',
  },
  {
    category: '壽險與家庭責任',
    q: '保險功用的「12345」是什麼？',
    a: '可理解為：1 個目的是救急防貧；2 種資源是時間與金錢；3 種家庭責任包含父母、夫妻、子女；4 類壓力包含生活、養老、醫療、喪葬；5 種保障包含收入、財產、家族前途、家庭責任與生命價值。這是一個幫助理解保險整體功能的概念架構，實際規劃仍需依個人狀況調整。',
  },
  {
    category: '醫療與保障',
    q: '配置保險需要關注哪些要素？',
    a: '可關注續保條件、單年報銷天數、健康告知、賠付比例、自負額與槓桿率。最重要的是先理解自己的需求，再確認條款是否符合保障目的。建議不要只看保費高低，而是從保障結構與長期需求出發，做出更適合自己的選擇。',
  },
];

export default function FaqAccordion() {
  const [activeCategory, setActiveCategory] = useState('全部');
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  const filtered = activeCategory === '全部'
    ? faqs
    : faqs.filter((f) => f.category === activeCategory);

  const toggle = (i: number) => setOpenIdx(openIdx === i ? null : i);

  return (
    <section className="bg-white py-24 lg:py-32">
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-12">
          <p className="text-[#D4A373] font-semibold tracking-widest mb-3" style={{ fontSize: '1rem' }}>
            FREQUENTLY ASKED QUESTIONS
          </p>
          <h2
            className="font-serif font-bold text-[#5C5470]"
            style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)', lineHeight: '1.4' }}
          >
            常見問題解答
          </h2>
          <div className="w-14 h-1 bg-[#D4A373] mx-auto rounded-full mt-4"></div>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap gap-3 justify-center mb-12">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => { setActiveCategory(cat); setOpenIdx(null); }}
              className={`px-5 py-2.5 rounded-full font-medium whitespace-nowrap transition-all duration-200 cursor-pointer
                ${activeCategory === cat
                  ? 'bg-[#5C5470] text-white'
                  : 'bg-[#F8F5F0] border border-gray-200 text-gray-600 hover:border-[#5C5470] hover:text-[#5C5470]'
                }`}
              style={{ fontSize: '1.0625rem' }}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Accordion */}
        <div className="space-y-3">
          {filtered.map((faq, i) => {
            const isOpen = openIdx === i;
            return (
              <div
                key={i}
                className={`rounded-2xl border transition-all duration-200 overflow-hidden
                  ${isOpen ? 'border-[#D4A373]/50' : 'border-gray-100 hover:border-[#D4A373]/30'}`}
                style={{ boxShadow: isOpen ? '0 2px 16px 0 rgba(212,163,115,0.10)' : '0 1px 6px 0 rgba(92,84,112,0.04)' }}
              >
                {/* Question Button */}
                <button
                  onClick={() => toggle(i)}
                  className="w-full flex items-start justify-between gap-4 px-7 py-5 text-left cursor-pointer bg-white hover:bg-[#F8F5F0] transition-colors duration-200"
                  aria-expanded={isOpen}
                >
                  <div className="flex items-start gap-4 flex-1">
                    {/* Category dot */}
                    <span
                      className="mt-1.5 w-2 h-2 rounded-full flex-shrink-0"
                      style={{
                        backgroundColor:
                          faq.category === '醫療與保障' ? '#FF8C69'
                          : faq.category === '壽險與家庭責任' ? '#5C5470'
                          : faq.category === '退休與長照' ? '#D4A373'
                          : '#5C5470',
                      }}
                    ></span>
                    <span
                      className={`font-semibold transition-colors duration-200 ${isOpen ? 'text-[#D4A373]' : 'text-[#5C5470]'}`}
                      style={{ fontSize: '1.1875rem', lineHeight: '1.6' }}
                    >
                      {faq.q}
                    </span>
                  </div>
                  <div
                    className={`w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-300 mt-0.5
                      ${isOpen ? 'bg-[#D4A373] rotate-180' : 'bg-[#F8F5F0]'}`}
                  >
                    <i
                      className={`ri-arrow-down-s-line text-lg ${isOpen ? 'text-white' : 'text-[#5C5470]'}`}
                    ></i>
                  </div>
                </button>

                {/* Answer */}
                <div
                  className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96' : 'max-h-0'}`}
                >
                  <div className="px-7 pb-6 pt-1">
                    <div className="pl-6 border-l-2 border-[#D4A373]/40">
                      <p
                        className="text-gray-600"
                        style={{ fontSize: '1.1875rem', lineHeight: '1.85' }}
                      >
                        {faq.a}
                      </p>
                    </div>
                    {/* Category tag */}
                    <div className="mt-4 pl-6">
                      <span
                        className="inline-block px-3 py-1 rounded-full text-white font-medium"
                        style={{
                          fontSize: '1rem',
                          backgroundColor:
                            faq.category === '醫療與保障' ? '#FF8C69'
                            : faq.category === '壽險與家庭責任' ? '#5C5470'
                            : faq.category === '退休與長照' ? '#D4A373'
                            : '#5C5470',
                        }}
                      >
                        {faq.category}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
